<template>
  <div class="verify-card">
    <div class="verify-bar"></div>

    <div class="verify-icon" :class="status">
      <template v-if="status === 'pending'">
        <img src="../../assets/images/svg-icon/shield.svg" height="32" />
      </template>
      <template v-else-if="status === 'success'">
        <div class="success-icon">✓</div>
      </template>
      <template v-else>
        <div class="error-icon">!</div>
      </template>
    </div>

    <template v-if="status === 'pending'">
      <h2>Recuperar contraseña</h2>
      <p class="text-muted">
        Ingresa tu correo y te enviaremos un código para cambiar tu contraseña.
      </p>

      <input
        type="email"
        class="form-control form-control-lg mt-4"
        placeholder="usuario@ejemplo.com"
        v-model="localEmail"
        @input="normalizeEmail"
        @blur="v$.localEmail.$touch()"
        @keyup.enter="submitRecover"
        :class="{ 'is-invalid': v$.localEmail.$error }"
      />

      <div class="invalid-feedback d-block text-start mt-2" v-if="v$.localEmail.$error">
        {{ v$.localEmail.$errors[0].$message }}
      </div>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="submitRecover">
        Enviar código
      </button>
    </template>

    <template v-else-if="status === 'success'">
      <h2>Revisa tu correo</h2>
      <p class="text-muted">
        Si existe una cuenta con el correo<br />
        <strong>{{ email }}</strong><br />
        te enviamos un código de recuperación.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="$emit('login')">
        Volver al inicio
      </button>

      <p class="resend mt-3">
        ¿No te llegó el correo?
        <a href="javascript:void(0)" @click="$emit('resend')">Reenviar código</a>
      </p>
    </template>

    <template v-else>
      <h2>No se pudo enviar el correo</h2>
      <p class="text-muted">
        Ocurrió un problema al iniciar la recuperación de contraseña.<br />
        Intenta nuevamente en unos minutos.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="$emit('retry')">
        Reintentar
      </button>
    </template>
  </div>
</template>

<script>
import { normalizeEmail as normalizeEmailValue } from '@/mixins/normalizers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'

export default {
  name: 'RecoverStatusCard',
  props: {
    email: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'pending' // pending | success | error
    }
  },
  data() {
    return {
      localEmail: this.email || '',
    };
  },
  validations() {
    return {
      localEmail: {
        required: helpers.withMessage('Ingresa tu correo electrónico', required),
        email: helpers.withMessage('Ingresa un correo válido', email)
      }
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  watch: {
    email(newValue) {
      this.localEmail = normalizeEmailValue(newValue);
      this.v$.$reset();
    }
  },
  methods: {
    normalizeEmail() {
      this.localEmail = normalizeEmailValue(this.localEmail);
    },
    submitRecover() {
      const email = normalizeEmailValue(this.localEmail);
      this.localEmail = email;
      this.v$.localEmail.$touch();

      if (this.v$.localEmail.$invalid) {
        return;
      }

      this.$emit('recover', email);
    }
  }
};
</script>
